import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setMessage("");
    const generic = "If an account exists for that email, we've sent a reset link. Check your inbox (and spam folder). The link expires in 60 minutes.";
    try {
      const r = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setMessage(r?.data?.message || generic);
    } catch {
      // We deliberately show the same message on any failure — matches the backend's
      // "no account enumeration" contract.
      setMessage(generic);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-[1fr_480px]" data-testid="forgot-password-root">
      <div className="p-12 hidden md:flex flex-col justify-between" style={{ background: "var(--ink)", color: "var(--cream-2)" }}>
        <Link to="/" className="text-2xl font-display font-black">Ask<span style={{ color: "var(--kiwi-2)" }}>Tax</span></Link>
        <div>
          <span className="eyebrow light">Password recovery</span>
          <h1 className="h1-display mt-4" style={{ fontSize: 56 }}>
            Lost the key.<br /><span className="font-serif-i font-normal" style={{ textTransform: "none", color: "var(--kiwi-2)" }}>Send it again.</span>
          </h1>
          <p className="mt-6 font-serif text-lg" style={{ color: "var(--cream-3)" }}>
            Enter the email you use for AskTax. If the account exists we'll send a single-use link that expires in 60 minutes.
          </p>
        </div>
        <div className="text-xs" style={{ color: "var(--muted-2)" }}>IRD-registered New Zealand tax agent</div>
      </div>
      <div className="p-8 md:p-12 flex items-center justify-center" style={{ background: "var(--cream)" }}>
        <form onSubmit={submit} className="at-card p-8 w-full max-w-md">
          <div className="text-2xl font-display font-black uppercase">Forgot password</div>
          <div className="mt-1 font-serif italic" style={{ color: "var(--muted)" }}>We'll email you a reset link.</div>
          {message && (
            <div className="mt-4 p-3 border-2 text-sm font-serif" style={{ borderColor: "var(--ink)", background: "var(--cream-3)", color: "var(--ink)" }} data-testid="forgot-password-message">
              {message}
            </div>
          )}
          <div className="mt-6">
            <label className="at-label">Email</label>
            <input className="at-input" type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="forgot-password-email" />
          </div>
          <button disabled={busy || !email} className="at-btn block mt-6" data-testid="forgot-password-submit">
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <div className="mt-4 text-sm">
            Remembered it? <Link to="/login" className="font-bold" style={{ color: "var(--kiwi)" }} data-testid="forgot-back-to-login">Back to sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
